async function call(method, path, body, token, { keepalive = false } = {}) {
  const res = await fetch(path, {
    method,
    keepalive,
    headers: { "content-type": "application/json", ...(token ? { authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch { /* empty */ }
  if (!res.ok) {
    const err = new Error(data.error || `Something went wrong (${res.status}).`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const getLink = (code) => call("GET", `/api/link/${encodeURIComponent(code)}`);
export const resolveCode = (code, last4) => call("POST", "/api/code", { code, last4 });
export const joinPass = (code, name) => call("POST", "/api/join", { code, name });
export const moderate = (code, action, extra = {}) => call("POST", "/api/moderate", { code, action, ...extra });
export const createMeeting = (adminToken, body) => call("POST", "/api/meetings", body, adminToken);
export const bookVisit = (code, at, pickup) => call("POST", "/api/book", { code, at, pickup });
// The site camera's link (stage 11): his own code asks; fresh withdraws the old one and makes another.
export const siteLink = (code, fresh = false) => call("POST", "/api/site", { code, fresh: Boolean(fresh) });
// The whiteboard kept (W4): his pages written whole, read back on a new tab or laptop; the stills as JPEGs. His own
// code, in the body or a header — never in a URL.
export const keepInk = (code, pages, base, opts) => call("POST", "/api/ink", { code, pages, base }, undefined, opts);
export const readKept = (code) => call("POST", "/api/ink", { code });
export async function keepStill(code, n, w, h, blob) {
  const res = await fetch("/api/still", { method: "PUT", headers: { "x-studio-code": code, "x-still": `${n}-${w}x${h}`, "content-type": "image/jpeg" }, body: blob });
  if (!res.ok) throw Object.assign(new Error(`the still was not kept (${res.status})`), { status: res.status });
}
export async function readStill(code, n) {
  const res = await fetch("/api/still", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ code, n }) });
  if (!res.ok) throw Object.assign(new Error(`no still ${n} (${res.status})`), { status: res.status });
  return res.blob();
}
export const getSummary = (code) => call("GET", `/api/summary?code=${encodeURIComponent(code)}`);
// Events go on a keepalive request, so the last batch still arrives when the page is closing.
export function postEvents(code, events) {
  if (!events.length) return Promise.resolve();
  return fetch("/api/events", { method: "POST", keepalive: true, headers: { "content-type": "application/json" }, body: JSON.stringify({ code, events }) }).catch(() => {});
}
// ClikMeet's room (M3): the page before anyone is in, a guest's knock and its answer, and the host at the door. A knock's
// secret and the host's code travel in the body, never in a URL.
export const getRoom = (room) => call("GET", `/api/rooms/${encodeURIComponent(room)}`);
export const knockAt = (room, name) => call("POST", `/api/rooms/${encodeURIComponent(room)}/knock`, { name });
export const knockState = (room, id, secret) => call("POST", `/api/rooms/${encodeURIComponent(room)}/knock/status`, { id, secret });
export const door = (code, action, id) => call("POST", "/api/knocks", { code, action, ...(id ? { id } : {}) });
// A ClikMeet room's chat, kept (CR-20260926-001 F7): the person's own code in the body.
export const keepChat = (code, msg) => call("POST", "/api/chat", { code, id: msg.id, text: msg.text, name: msg.name });
export const readChatLog = (code) => call("POST", "/api/chat", { code, action: "list" });
